import tickettypes from "./tickettypes.component";
import tickettypesUrls from "./tickettypes.urls";
import TickettypesTransforms from "./tickettypes.transforms";

const tickettypesModule = angular
  .module("app.components.tickettypes", [])
  .component("tickettypesPage", tickettypes)
  .service("TickettypesTransforms", TickettypesTransforms)
  .config(tickettypesUrls);

export default tickettypesModule;



// WEBPACK FOOTER //
// ./src/pages/tickettypes/tickettypes.module.js